export const domesticViolenceSupport = {
    'meta': {
        'title': 'Grupa wsparcia dla osób z doświadczeniem przemocy w rodzinie #cityLocativeIn# • Centrum Psychoterapii COLLIGO',
        'description': 'W spotkaniach grupy wsparcia dla osób z doświadczeniem krzywdzenia w rodzinie mogą wziąć udział wszystkie osoby uwikłane w przemoc, które jej doświadczały, aktualnie doświadczają lub świadkowie przemocy w rodzinie.'
    },
    'availability': [
        'torun',
        'bydgoszcz'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/grupa-wsparcia-osob-z-doswiadczeniem-przemocy/torun/',
        'title': 'Grupa wsparcia dla osób z doświadczeniem przemocy w rodzinie #cityLocativeIn#',
        'name': 'Grupa wsparcia dla osób z doświadczeniem przemocy w rodzinie #cityLocativeIn#',
        'heading': 'Grupa wsparcia dla osób z doświadczeniem przemocy w rodzinie',
        'fullName': 'Grupa wsparcia dla osób z doświadczeniem przemocy w rodzinie'
    },
    'image': {
        'url': '/images/services/grupa-wsparcia-przemoc-domowa.webp',
        'width': 840,
        'height': 321,
        'alt': 'Grupa wsparcia dla osób z doświadczeniem przemocy w rodzinie #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/grupa-wsparcia-przemoc-domowa.webp',
            'width': 840,
            'height': 321,
            'alt': 'Grupa wsparcia dla osób z doświadczeniem przemocy w rodzinie #cityLocativeIn#'
        }
    }
}